import * as Sentry from '@sentry/browser';
import { Button } from './components';
import { useNavigate } from '@tanstack/react-router';
import { useAuth } from './contexts/AuthContext';

export function NotFound() {
  const { currentUser } = useAuth();
  Sentry.captureMessage('404: Page Not Found');
  const navigate = useNavigate();
  return (
    <div className="flex h-screen flex-col items-center justify-center bg-stone-100">
      <img
        src="https://storage.googleapis.com/mideoid-console-public/logos/MIDEOhealth.png"
        alt="mideo_logo"
        className="h-36"
      />

      <h1 className="text-2xl font-bold">Error 404: - Page Not Found!</h1>
      <Button
        id="home"
        type="button"
        textContent="Go Home"
        onClick={() =>
          navigate(currentUser ? { to: '/$patientId', params: { patientId: currentUser.uid } } : { to: '/login' })
        }
      />
      <h1 className="text-2xl">You may be asked to reauthenticate.</h1>
    </div>
  );
}
